import {default as classNames} from "classnames";
import {PropsWithChildren, ReactNode} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {isFreeTrialExpired} from "@/lib/userUtils.ts";

interface HeaderProps extends PropsWithChildren {
  title: string | ReactNode;
  actionsBar?: ReactNode;
  className?: string;
}

const Header = ({title, actionsBar, className, children}: HeaderProps) => {
  const {user} = useCurrentUserContext();
  const readOnly = isFreeTrialExpired(user);
  return (
    <>
      <div className="d-flex justify-content-between">
        <div className={"align-content-center"}>
          <div className={classNames("pulseTextH1Bold", className)} data-testid="heading">
            {title}
          </div>
        </div>
        {!readOnly && actionsBar && <span className="float-end">{actionsBar}</span>}
      </div>
      <div>{children}</div>
    </>
  );
};

export default Header;
